import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../services/api/axiosInstance";
import "../../stylesheets/Employer.css";

import {
  MdAddAPhoto,
  MdDelete,
  MdModeEditOutline,
  MdOutlineLocationOn,
  MdSave,
} from "react-icons/md";
import { PiBagFill } from "react-icons/pi";
import { SlGlobe } from "react-icons/sl";
import { SiAwsorganizations } from "react-icons/si";
import { GoOrganization } from "react-icons/go";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { FaUserTie } from "react-icons/fa";
import { RiMedal2Line, RiTeamFill } from "react-icons/ri";
import { BiEdit, BiEnvelope, BiMedal, BiUserPin } from "react-icons/bi";
import { TbPhone } from "react-icons/tb";
import { TfiMedallAlt } from "react-icons/tfi";
import { RiVerifiedBadgeLine } from "react-icons/ri";
import { FiInfo } from "react-icons/fi";
import PhoneInput from "react-phone-input-2";
import toast from "react-hot-toast";
import Autocomplete from "react-google-autocomplete";
import employerContext from "../../hooks/employerContext";
import { HiOutlineBriefcase } from "react-icons/hi";
import Cookies from "js-cookie";

const EmployerProfile = () => {
  const { setProfilePicture } = useContext(employerContext)
  const pricing_category = Cookies.get("pricing_category")?.toLowerCase()
  const [firstTimeEmployerProfileRender, setFirstTimeEmployerProfileRender] = useState(false)
  const [mobileScreen, setMobileScreen] = useState(window.innerWidth)
  const [isHovered, setIsHovered] = useState(false)
  const [isAdminHovered, setIsAdminHovered] = useState(false)
  const [employerProfilePageResponse, setEmployerProfilePageResponse] = useState(false)
  const [employerProfilePageRefresh, setEmployerProfilePageRefresh] = useState(false)
  const [companyPicture, setCompanyPicture] = useState("")
  const [companyName, setCompanyName] = useState("");
  const [currentPlan, setCurrentPlan] = useState(false)
  const [deleteCompanyLogoSaveLoading, setDeleteCompanyLogoSaveLoading] = useState(false)
  const [employerDetailsSaveLoading, setEmployerDetailsSaveLoading] = useState(false)
  const [editClick, setEditClick] = useState(false)
  const [isPictureUploading, setIsPictureUploading] = useState(false)
  const [isPictureDeleting, setIsPictureDeleting] = useState(false)
  const [isCompanyPictureUploaded, setIsCompanyPictureUploaded] = useState(false)
  const [showingLocation, setShowingLocation] = useState("")
  const [editIconClicked, setEditIconClicked] = useState(false)
  const [countryCode, setCountryCode] = useState(null);
  const [dialCode, setDialCode] = useState("");
  const [companyDetails, setCompanyDetails] = useState({
    website: "",
    organization: "",
    industrySector: "",
  })
  const [companyLocation, setCompanyLocation] = useState({
    city: "",
    country: "",
  })
  const [editCompanyLocation, setEditCompanyLocation] = useState({
    city: "",
    country: "",
  })
  const [editCompanyDetails, setEditCompanyDetails] = useState({
    website: "",
    organization: "",
    industrySector: "",
  })
  const [editHiringTeamInputValues, setEditHiringTeamInputValues] = useState({
    empId: "",
    firstName: "",
    lastName: "",
    designation: "",
    countryCode: "",
    contactNumber: "",
  })

  const [recuriterEdit, setRecuriterEdit] = useState(false)
  const [addUserInputValues, setAddUserInputValues] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
    designation: "",
    contact_number: "",
    country_code: "",
    access_type: "",
    sub_user_id: ""
  })
  const [hiringTeamArray, setHiringTeamArray] = useState([]);
  const [deleteUserId, setDeleteUserId] = useState(null)
  const [edit_type, set_edit_type] = useState('')


  const handlePhoneInput = (e, phone, contactno) => {
    setEditHiringTeamInputValues((prevState) => ({
      ...prevState,
      contactNumber: e.slice(phone.dialCode.length),
      countryCode: phone.dialCode,
    }));

    setCountryCode(phone.dialCode);
    setDialCode(phone.dialCode);
  };

  const handleLocation = (selectedLocation) => {
    const countryComponent = selectedLocation.find((component) =>
      component.types.includes("country")
    );

    if (countryComponent) {
      setEditCompanyLocation({
        city: selectedLocation[0].long_name,
        country: countryComponent.long_name,
      });
      setShowingLocation(
        `${selectedLocation[0].long_name} , ${countryComponent.long_name}`
      );
    }
  }

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 588) {
      setMobileScreen(screenWidth);
    } else {
      setMobileScreen(null);
    }
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const getEmployerPageData = async () => {
      try {
        const response = await axiosInstance.get("/employer_profile_dashboard");
        if (response.data.error_code === 0) {
          setEmployerProfilePageResponse(true);
          setHiringTeamArray(response?.data?.data?.hiring_team)
          setCompanyDetails({
            website: response.data.data.website_url,
            organization: response.data.data.org_type,
            industrySector: response.data.data.sector,
          });
          setCompanyLocation({
            city: response.data.data.city,
            country: response.data.data.country,
          });
          setCompanyPicture(
            `${process.env.REACT_APP_SECOND_CAREERS_CDN}${response.data.data.profile_image}`
          );
          setCurrentPlan(response.data.data.pricing_category);
          setCompanyName(response.data.data.company_name);
          setOrganizationAboutContent(response.data.data.company_description);
          setCountryCode(response.data.data.hiring_team[0].country_code);
        } else if (response.data.error_code === 200) {
          setFirstTimeEmployerProfileRender(true);
        }
      } catch (err) {
        console.log(err);
      }
    };

    (async () => getEmployerPageData())();
  }, [employerProfilePageRefresh]);

  const handleEditClick = () => {
    setEditClick(true);
    setEditCompanyLocation({
      city: companyLocation.city,
      country: companyLocation.country,
    });
    setShowingLocation(`${companyLocation.city} , ${companyLocation.country}`);
  };

  const handleSaveClick = async () => {
    if (
      companyDetails.website === "" ||
      companyDetails.designation === "" ||
      companyDetails.contact_number === "" ||
      showingLocation === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    }

    const companyDetailsParams = {
      website_url: companyDetails.website,
      sector: companyDetails.industrySector,
      org_type: companyDetails.organization,
      country: editCompanyLocation.country,
      city: editCompanyLocation.city,
    };

    try {
      setEditClick(false);

      const response = await axiosInstance.post(
        "/update_company_details",
        companyDetailsParams
      );

      if (response.data.error_code === 0) {
        setEditClick(false);
        setEmployerProfilePageRefresh(!employerProfilePageRefresh);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleEditCompanyDetails = (e, type, industry) => {
    if (e.target.name === "website") {
      setCompanyDetails((prevState) => ({
        ...prevState,
        website: e.target.value,
      }));
      return;
    }

    if (type !== null) {
      setCompanyDetails((prevState) => ({
        ...prevState,
        organization: type,
      }));
    }
    if (industry !== null) {
      setCompanyDetails((prevState) => ({
        ...prevState,
        industrySector: industry,
      }));
    }
  };

  //  company profile photo upload
  const handleCompanyPictureUpload = async (e) => {
    try {
      setIsPictureUploading(true);

      const file = e.target.files[0];

      if (
        file.name.includes(".png") ||
        file.name.includes(".jpeg") ||
        file.name.includes(".jpg") ||
        file.name.includes(".PNG") ||
        file.name.includes(".JPEG") ||
        file.name.includes(".JPG") ||
        file.name.includes(".HEIC")
      ) {
        const formData = new FormData();
        formData.append("profile_pic", file);

        const response = await axiosInstance.post(
          "/upload_user_profile_pic",
          formData
        );

        if (response.data.error_code === 0) {
          setCompanyPicture(
            `${process.env.REACT_APP_SECOND_CAREERS_CDN}${response.data.data.picture_name}`
          );
          setProfilePicture(
            `${process.env.REACT_APP_SECOND_CAREERS_CDN}${response.data.data.picture_name}`
          );
          setIsPictureUploading(false);
          setIsCompanyPictureUploaded(true);
        } else {
          setIsPictureUploading(false);
          setIsCompanyPictureUploaded(false);
        }
      } else {
        toast.error(
          "Unsupported file format. Please upload .jpeg, .jpg, .png, .JPEG, .JPG, .PNG, .HEIC files only."
        );
        setIsPictureUploading(false);
        setIsCompanyPictureUploaded(false);
      }
    } catch (err) {
      console.log(err);
      setIsPictureUploading(true);
    }
  };

  // handle delete company picture
  const handleDeleteCompanyPicture = async () => {
    try {
      setIsPictureDeleting(true);
      setDeleteCompanyLogoSaveLoading(true);

      const response = await axiosInstance.post(
        "/delete_user_profile_pic",
        null
      );

      if (response.data.error_code === 0) {
        setDeleteCompanyLogoSaveLoading(false);

        document
          .getElementById("deleteProfilePhotoModalConfirmationModal")
          .click();
        setEmployerProfilePageRefresh(!employerProfilePageRefresh);
        setCompanyPicture(
          "https://cdn.2ndcareers.com/professional/profile-pic/default_profile_picture.png"
        );
        setProfilePicture(
          "https://cdn.2ndcareers.com/professional/profile-pic/default_profile_picture.png"
        );
        setIsCompanyPictureUploaded(false);
        setIsPictureDeleting(false);
      } else {
        setIsCompanyPictureUploaded(false);
        setIsPictureDeleting(false);
        setDeleteCompanyLogoSaveLoading(false);
      }
    } catch (err) {
      console.log(err);
      setDeleteCompanyLogoSaveLoading(false);
    }
  };

  const typesOfOrganization = [
    {
      id: 1,
      type: "Large (5000+ employees)",
    },
    {
      id: 2,
      type: "Medium (1001 - 5000 employees)",
    },
    {
      id: 3,
      type: "Small (251 - 1000 employees)",
    },
    {
      id: 4,
      type: "Startup (0 - 250 employees)",
    },
    {
      id: 5,
      type: "Non-profit",
    },
  ];

  const industrySectors = [
    {
      id: 1,
      industry: "Agriculture",
    },
    {
      id: 2,
      industry: "Arts",
    },
    {
      id: 3,
      industry: "Construction",
    },
    {
      id: 4,
      industry: "Consumer Goods",
    },
    {
      id: 5,
      industry: "Corporate Services",
    },
    {
      id: 6,
      industry: "Design",
    },
    {
      id: 7,
      industry: "Education",
    },
    {
      id: 8,
      industry: "Energy and Mining",
    },
    {
      id: 9,
      industry: "Entertainment",
    },
    {
      id: 10,
      industry: "Finance",
    },
    {
      id: 11,
      industry: "Hardware and Networking",
    },
    {
      id: 12,
      industry: "Health Care",
    },
    {
      id: 13,
      industry: "Legal",
    },
    {
      id: 14,
      industry: "Manufacturing",
    },
    {
      id: 15,
      industry: "Media and Communications",
    },
    {
      id: 16,
      industry: "Nonprofit",
    },
    {
      id: 17,
      industry: "Public Administration",
    },
    {
      id: 18,
      industry: "Public Safety",
    },
    {
      id: 25,
      industry: "Professional Services",
    },
    {
      id: 19,
      industry: "Real Estate",
    },
    {
      id: 20,
      industry: "Recreation and Travel",
    },
    {
      id: 21,
      industry: "Retail",
    },
    {
      id: 22,
      industry: "Software and IT Services",
    },
    {
      id: 23,
      industry: "Transportation and Logistics",
    },
    {
      id: 24,
      industry: "Wellness and Fitness",
    },
    {
      id: 26,
      industry: "Others",
    },
  ];

  const [organizationAboutContent, setOrganizationAboutContent] = useState("");

  const handleEditHiringTeamInputValues = (e) => {
    if (e.target.name === "contactNumber") {
      if (isNaN(e.target.value)) {
        toast("Only numbers are allowed ", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
      } else {
        setEditHiringTeamInputValues((prevState) => ({
          ...prevState,
          contactNumber: e.target.value,
        }));
      }
    } else {
      setEditHiringTeamInputValues((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  }

  const handleAddUserInputValues = (field, value) => {
    if (field === "contact_number") {
      setAddUserInputValues((prevState) => ({
        ...prevState,
        "contact_number": value?.phone_number,
        "country_code": value?.country_code,
      }))

    } else {
      setAddUserInputValues((prevState) => ({
        ...prevState,
        [field]: value,
      }))
    }
  };

  const handleResetAddUSers = () => {
    setAddUserInputValues({
      first_name: "",
      last_name: "",
      email_id: "",
      designation: "",
      contact_number: "",
      country_code: "",
      access_type: "",
      sub_user_id: ""
    })

    setEditHiringTeamInputValues({
      contactNumber: '',
      countryCode: '',
    })

    setRecuriterEdit(false)
  }

  function isValidEmail(email_id) {
    const regex = /^[a-zA-Z0-9._%+-]+@(?!gmail\.com$|yahoo\.com$|hotmail\.com$|rediffmail\.com$)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return regex.test(email_id);
  }

  const handleNewUserEditOrAdd = async (endpoint) => {
    if (addUserInputValues.first_name &&
      addUserInputValues.last_name &&
      addUserInputValues.email_id &&
      addUserInputValues.designation &&
      addUserInputValues.contact_number &&
      addUserInputValues.country_code &&
      addUserInputValues.access_type) {

      const params = { ...addUserInputValues }
      params.contact_number = editHiringTeamInputValues?.contactNumber
      params.email_id = addUserInputValues.email_id?.toLowerCase()?.trim()

      if (isValidEmail(addUserInputValues.email_id)) {
        const { data } = await axiosInstance.post(endpoint, params)

        if (data?.error_code === 0) {
          document.getElementById('closeAdduserModal')?.click()
          setEmployerProfilePageResponse(false)
          setEmployerProfilePageRefresh(!employerProfilePageRefresh)
          handleResetAddUSers()
        }
      }
      else {
        toast.error('Please enter an official email')
      }
    } else {
      toast("All fields are required", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    }
  };

  const handleEditHiringTeam = (team) => {
    if (team?.role_name === "OWNER") {
      setEditHiringTeamInputValues({
        firstName: team?.first_name,
        lastName: team?.last_name,
        designation: team?.title,
        countryCode: team?.country_code,
        contactNumber: team?.phone_number,
      })

      setRecuriterEdit(false)
    } else {
      setAddUserInputValues({
        ...team,
        contact_number: team?.phone_number,
        access_type: team?.role_name,
        designation: team?.title,
        sub_user_id: team?.user_id
      })

      setEditHiringTeamInputValues({
        countryCode: team?.country_code,
        contactNumber: team?.phone_number
      })

      set_edit_type(team?.role_name)
      setRecuriterEdit(true)
    }

  };

  // update hiring team
  const handleUpdateHiringTeam = async (e, saveClick) => {
    if (
      editHiringTeamInputValues.firstName === "" ||
      editHiringTeamInputValues.lastName === "" ||
      editHiringTeamInputValues.designation === "" ||
      editHiringTeamInputValues.contactNumber === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    } else {
      const updateHiringTeamParams = {
        emp_id: hiringTeamArray.id,
        first_name: editHiringTeamInputValues.firstName.trim(),
        last_name: editHiringTeamInputValues.lastName.trim(),
        designation: editHiringTeamInputValues.designation,
        contact_number: editHiringTeamInputValues.contactNumber,
        country_code: countryCode,
      };

      try {
        setEmployerDetailsSaveLoading(true);

        const response = await axiosInstance.post(
          "/update_hiring_team_details",
          updateHiringTeamParams
        );
        if (response.data.error_code === 0) {
          setEmployerDetailsSaveLoading(false);

          if (saveClick === "Save") {
            document.getElementById("updateExperienceClose").click();
          }
          setEmployerProfilePageRefresh(!employerProfilePageRefresh);
        }
      } catch (err) {
        console.log(err);
        setEmployerDetailsSaveLoading(false);
      }
    }
  };

  const handleDeleteUser = async (deteltionParams) => {
    try {
      const { data } = await axiosInstance.post("/delete_team_members", { sub_user_id: deteltionParams?.user_id })

      if (data?.error_code === 0) {
        document.getElementById('deleteUserModal')?.click()
        setEmployerProfilePageResponse(false)
        setEmployerProfilePageRefresh(!employerProfilePageRefresh)
      }
    } catch (Err) {
      console.log(Err?.message)
    }
  }

  const handleAboutEditOrSaveIcon = () => {
    setEditIconClicked(true);
  };

  const handleAboutSaveClick = async () => {
    if (
      organizationAboutContent.trim() === "" ||
      organizationAboutContent === ""
    ) {
      toast("Please fill the field.", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    } else {
      const aboutParams = {
        org_desc: organizationAboutContent,
      };

      try {
        const response = await axiosInstance.post(
          "/update_org_description",
          aboutParams
        );
        if (response.data.error_code === 0) {
          setEditIconClicked(false);
          setEmployerProfilePageRefresh(!employerProfilePageRefresh);
        } else {
          setEditIconClicked(true);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleOrganizationAboutContentChange = (e) => {
    setOrganizationAboutContent(e.target.value);
  };

  function disableAddUserFunction() {
    if (pricing_category === "basic" && parseInt(process.env.REACT_APP_EMPLOYER_BASIC_PROFILE_LIMIT) <= hiringTeamArray.length) {
      return true
    }

    if (pricing_category === "premium" && parseInt(process.env.REACT_APP_EMPLOYER_PREMIUM_PROFILE_LIMIT) <= hiringTeamArray.length) {
      return true
    }

    if (pricing_category === "platinum" && parseInt(process.env.REACT_APP_EMPLOYER_PLATINUM_PROFILE_LIMIT) <= hiringTeamArray.length) {
      return true
    }
  }

  function userType(type) {
    switch (type) {
      case "OWNER":
        return "Owner Access"

      case "employer_sub_admin":
        return "Admin Access"

      case "recruiter":
        return "Recruiter Access"

      default:
        break;
    }
  }

  function profileEditButton(team) {
    return <button
      type="button"
      title="Employer Details"
      className={
        employerProfilePageResponse
          ? "btn btn-sm btn-outline-custom-color px-3 d-flex align-items-center gap-2 me-2"
          : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2 me-2"
      }
      data-bs-toggle="modal"
      data-bs-target={team?.role_name === "OWNER" ? "#editHiringTeamModal" : "#adduserModal"}
      onClick={() => handleEditHiringTeam(team)}
    >
      {mobileScreen ? (
        <MdModeEditOutline />
      ) : (
        <>
          <MdModeEditOutline /> Edit
        </>
      )}
    </button>
  }

  function editFunDynamicProfile(team) {
    switch (Cookies.get("user_role")) {
      //for owner access
      case "employer":
        return profileEditButton(team)

      //for admin access
      case "employer_sub_admin":
        switch (team?.role_name) {
          case "employer_sub_admin":
            if (Cookies.get("id") == team?.user_id) {
              return profileEditButton(team)
            }
            break;

          case "recruiter":
            return profileEditButton(team)

          default:
            break;
        }

      //for admin access
      case "recruiter":
        switch (team?.role_name) {
          case "recruiter":
            if (Cookies.get("id") == team?.user_id) {
              return profileEditButton(team)
            }
            break;

          default:
            break;
        }

      default:
        break;
    }
  }

  function profileDeleteButton(team) {
    return <button
      type="button"
      data-bs-toggle="modal"
      data-bs-target="#deleteHiringTeamModal"
      className={
        employerProfilePageResponse
          ? "btn btn-sm btn-outline-custom-color px-3 d-flex align-items-center gap-2 me-2"
          : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2 me-2"
      }
      onClick={() => setDeleteUserId(team)}>
      <MdDelete />
    </button>
  }

  function deleteFunDynamicProfile(team) {
    switch (Cookies.get("user_role")) {
      //for owner access
      case "employer":
        switch (team?.role_name) {
          case "employer_sub_admin":
          case "recruiter":
            return profileDeleteButton(team)

          default:
            break;
        }

      //for admin access
      case "employer_sub_admin":
        switch (team?.role_name) {
          case "recruiter":
            return profileDeleteButton(team)

          default:
            break;
        }

      default:
        break;
    }
  }

  return (
    <section className="employer-profile min-vh-100">
      {/* top content*/}
      <div className="">
        <div className="container-fluid pt-5">
          <div className={`row  ${mobileScreen ? "px-3" : "px-5"}`}>
            <div className="col-lg-4 px-0 pe-lg-3 ">
              <div className="card shadow-sm rounded-4 border-0 py-5 h-100 ">
                <div className="card-body d-flex align-items-center justify-content-center pt-1">
                  <div className="w-100 ">
                    <div className="row justify-content-center p-0">
                      <div className="pic-holder mb-0  w-75">
                        {employerProfilePageResponse ? (
                          isPictureUploading || isPictureDeleting ? (
                            <div className="d-flex justify-content-center">
                              <div
                                className="spinner-border brand-color"
                                role="status"
                              >
                                <span className="visually-hidden ">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div
                                className="company-logo-container rounded-0"
                                id="employerUploadProfilePhoto"
                              >
                                <img
                                  id="profilePic"
                                  name="profile_pic"
                                  src={companyPicture}
                                />
                              </div>
                            </>
                          )
                        ) : (
                          <div
                            style={{
                              width: "150",
                              height: "150",
                              borderRadius: 50,
                            }}
                          >
                            <div>
                              <img
                                name="profile_pic"
                                className=" bg-secondary opacity-25 "
                              />
                            </div>
                          </div>
                        )}

                        <label
                          htmlFor="newProfilePhoto"
                          className={
                            employerProfilePageResponse
                              ? `upload-file-block ${isPictureUploading || isPictureDeleting
                                ? "pe-none"
                                : null
                              } `
                              : "upload-file-block "
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#profilePhotoModal"
                        >
                          <div className="text-center">
                            <MdAddAPhoto className="fs-5 mb-3" />
                            <div className="">
                              Upload <br /> Organization Logo
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{ backgroundColor: "#dfdddd8d" }}
                  className={
                    employerProfilePageResponse
                      ? "premium-account-feauture-container position-absolute top-0 end-0 d-flex align-items-center p-2  rounded-2"
                      : "premium-account-feauture-container position-absolute top-0 end-0 d-flex align-items-center p-2  placeholder rounded-2"
                  }
                >
                  <div className="m-0 px-2">
                    {Cookies.get("payment_status") ?
                      currentPlan === "Basic" && Cookies.get("payment_status") === "trialing" ?
                        <span>
                          <RiVerifiedBadgeLine className="fs-5" /> Free Trial
                        </span>
                        : null || currentPlan === "Basic" ?
                          <span>
                            <TfiMedallAlt className="fs-5" /> {currentPlan}
                          </span>
                          : null || currentPlan === "Premium" ?
                            <span>
                              <BiMedal className="fs-5" /> {currentPlan}
                            </span>
                            : null || currentPlan === "Platinum" ?
                              <span>
                                <RiMedal2Line className="fs-5" /> {currentPlan}
                              </span>
                              : null
                      : null}
                  </div>
                  <span
                    className={
                      employerProfilePageResponse
                        ? "brand-color fs-6"
                        : "placeholder"
                    }
                  ></span>
                </div>
                <h3
                  className={
                    employerProfilePageResponse
                      ? "text-center company-name fw-bold mt-3 "
                      : "text-center fw-bold placeholder mx-3  rounded-3"
                  }
                >
                  {companyName}
                </h3>
              </div>
            </div>

            <div
              className={`col-lg-8  ${mobileScreen ? "mt-4" : ""
                } mt-4 mt-lg-0 px-0 `}
            >
              <div
                className={`card shadow-sm rounded-4 border-0 h-100  ${mobileScreen ? "px-0" : "px-4"
                  } `}
                id="organizationDetailsCard"
              >
                <div className=" d-flex justify-content-between my-3 mb-1 pe-3 px-3 pt-2">
                  <label className=" profile-side-headers d-flex align-items-center placeholder-glow ">
                    <PiBagFill
                      className={
                        employerProfilePageResponse
                          ? "me-3 brand-color fs-3"
                          : "me-3 fs-1 placeholder rounded-2"
                      }
                    />
                    <span
                      className={
                        employerProfilePageResponse
                          ? "company-details "
                          : "placeholder ps-3 w-100 py-1  rounded-1"
                      }
                    >
                      Organization Details
                    </span>
                  </label>
                  {
                    Cookies.get("user_role") !== "recruiter" ?
                      editClick === false ? (
                        <button
                          id="editEmployerCompanyDetailsButton"
                          type="button"
                          title="Edit company details"
                          className={
                            employerProfilePageResponse
                              ? "btn btn-sm btn-outline-custom-color px-3 d-flex align-items-center gap-2"
                              : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                          }
                          onClick={() => handleEditClick()}
                        >
                          {mobileScreen ? (
                            <MdModeEditOutline />
                          ) : (
                            <>
                              <MdModeEditOutline /> Edit
                            </>
                          )}
                        </button>
                      ) : (
                        <>
                          <button
                            id="saveCompanyDetails"
                            type="button"
                            title="Save company details"
                            className={
                              employerProfilePageResponse
                                ? "btn btn-sm btn-brand-color px-3 d-flex align-items-center gap-2"
                                : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                            }
                            onClick={() => handleSaveClick()}
                          >
                            {mobileScreen ? (
                              <MdSave />
                            ) : (
                              <>
                                <MdSave /> Save
                              </>
                            )}
                          </button>
                        </>
                      )
                      :
                      null}
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="card border-0">
                      <div className="card-body ">
                        <div className="mt-2">
                          <ul className="list-group list-group-flush placeholder-glow">
                            <div>
                              <li className="list-group-item py-3 border-0 d-flex align-items-center">
                                <SlGlobe
                                  className={
                                    employerProfilePageResponse
                                      ? "me-3"
                                      : "me-3 placeholder rounded-2"
                                  }
                                />
                                <span
                                  className={
                                    employerProfilePageResponse
                                      ? "company-heading"
                                      : "placeholder px-3 w-75 py-3 rounded-1 "
                                  }
                                >
                                  Website
                                </span>
                              </li>
                              {editClick === true ? (
                                <input
                                  id="employerWebsiteField"
                                  className="personal-detail-input ms-5 w-75 py-2"
                                  type="text"
                                  name="website"
                                  value={companyDetails.website}
                                  onChange={(e) => handleEditCompanyDetails(e)}
                                />
                              ) : (
                                <li
                                  className={
                                    employerProfilePageResponse
                                      ? "list-unstyled ms-5"
                                      : "list-unstyled ms-5 placeholder rounded-2 w-75"
                                  }
                                >
                                  {companyDetails.website}
                                </li>
                              )}
                            </div>
                            <hr />
                            <div>
                              <li className="list-group-item py-3 border-0 d-flex align-items-center">
                                <MdOutlineLocationOn
                                  className={
                                    employerProfilePageResponse
                                      ? "me-3"
                                      : "me-3 placeholder rounded-2"
                                  }
                                />
                                <span
                                  className={
                                    employerProfilePageResponse
                                      ? "company-heading"
                                      : "placeholder px-3 w-75 py-3 rounded-1"
                                  }
                                >
                                  Location
                                </span>
                              </li>
                              {editClick === true ? (
                                <Autocomplete
                                  className="employer-profile location-input ms-5 w-75 bg-transparent py-2"
                                  apiKey={
                                    process.env.REACT_APP_GOOGLE_PLACES_KEY
                                  }
                                  onPlaceSelected={(place) => {
                                    if (place) {
                                      handleLocation(place.address_components);
                                    }
                                  }}
                                  style={{
                                    width: "100%",
                                    border: "none",
                                    borderBottom: "2px solid #e381129f",
                                  }}
                                  required
                                  value={showingLocation}
                                  onChange={(e) =>
                                    setShowingLocation(e.target.value)
                                  }
                                />
                              ) : (
                                <li
                                  className={
                                    employerProfilePageResponse
                                      ? "list-unstyled ms-5"
                                      : "list-unstyled ms-5 placeholder rounded-2 w-75"
                                  }
                                >{`${companyLocation.city} , ${companyLocation.country}`}</li>
                              )}
                            </div>
                            <hr />
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card border-0 ">
                      <div className="card-body pt-0 pt-lg-3">
                        <div className={`${mobileScreen ? "mt-0" : "mt-2"}  `}>
                          <ul className="list-group list-group-flush placeholder-glow">
                            <div>
                              <li className="list-group-item py-3 border-0 d-flex align-items-center">
                                <SiAwsorganizations
                                  className={
                                    employerProfilePageResponse
                                      ? "me-3"
                                      : "me-3 placeholder rounded-2"
                                  }
                                />
                                <span
                                  className={
                                    employerProfilePageResponse
                                      ? "company-heading"
                                      : "placeholder px-3 w-75 py-3 rounded-1"
                                  }
                                >
                                  Organization Type
                                </span>
                              </li>
                              {editClick === true ? (
                                <div className="dropdown custom-dropdown ms-5">
                                  <button
                                    id="organizationTypeButton"
                                    className="btn btn-secondary dropdown-toggle w-100 p-2"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    {editCompanyDetails.organization === "" ? (
                                      <span className="text-custom-black">
                                        {companyDetails.organization.length > 20
                                          ? `${companyDetails.organization.slice(
                                            0,
                                            20
                                          )}..`
                                          : companyDetails.organization}
                                      </span>
                                    ) : (
                                      <span className="text-custom-black">
                                        {editCompanyDetails.organization.length
                                          ? `${editCompanyDetails.organization.slice(
                                            0,
                                            20
                                          )}`
                                          : editCompanyDetails.organization}
                                      </span>
                                    )}
                                  </button>
                                  <ul className="dropdown-menu">
                                    {typesOfOrganization.map((type) => {
                                      return (
                                        <React.Fragment key={type.id}>
                                          <li
                                            onClick={(e) =>
                                              handleEditCompanyDetails(
                                                e,
                                                type.type,
                                                null
                                              )
                                            }
                                          >
                                            <a className="dropdown-item text-custom-black text-wrap ">
                                              {type.type}
                                            </a>
                                          </li>
                                        </React.Fragment>
                                      );
                                    })}
                                  </ul>
                                </div>
                              ) : (
                                <li
                                  className={
                                    employerProfilePageResponse
                                      ? "list-unstyled ms-5"
                                      : "list-unstyled ms-5 placeholder rounded-2 w-75"
                                  }
                                >
                                  {companyDetails.organization.length > 20
                                    ? `${companyDetails.organization.slice(
                                      0,
                                      20
                                    )}..`
                                    : companyDetails.organization}
                                </li>
                              )}
                            </div>
                            <hr />
                            <div>
                              <li className="list-group-item py-3 border-0 d-flex align-items-center">
                                <GoOrganization
                                  className={
                                    employerProfilePageResponse
                                      ? "me-3"
                                      : "me-3 placeholder rounded-2"
                                  }
                                />
                                <span
                                  className={
                                    employerProfilePageResponse
                                      ? "company-heading"
                                      : "placeholder px-3 w-75 py-3 rounded-1"
                                  }
                                >
                                  Industry Sector
                                </span>
                              </li>
                              {editClick === true ? (
                                <div className="dropdown custom-dropdown ms-5">
                                  <button
                                    id="industrySectorButton"
                                    className="btn btn-secondary dropdown-toggle w-100 p-2"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    {editCompanyDetails.industrySector ===
                                      "" ? (
                                      <span className="text-custom-black text-wrap">
                                        {companyDetails.industrySector.length >
                                          20
                                          ? `${companyDetails.industrySector.slice(
                                            0,
                                            20
                                          )}..`
                                          : companyDetails.industrySector}
                                      </span>
                                    ) : (
                                      <span className="text-custom-black text-wrap">
                                        {editCompanyDetails.industrySector
                                          .length > 20
                                          ? `${editCompanyDetails.industrySector.slice(
                                            0,
                                            20
                                          )}..`
                                          : editCompanyDetails.industrySector}
                                      </span>
                                    )}
                                  </button>
                                  <ul className="dropdown-menu indutry-sector-dropdown-menu">
                                    {industrySectors.map((industry) => {
                                      return (
                                        <React.Fragment key={industry.id}>
                                          <li
                                            onClick={(e) =>
                                              handleEditCompanyDetails(
                                                e,
                                                null,
                                                industry.industry
                                              )
                                            }
                                          >
                                            <a className="dropdown-item text-custom-black text-wrap">
                                              {industry.industry}
                                            </a>
                                          </li>
                                        </React.Fragment>
                                      );
                                    })}
                                  </ul>
                                </div>
                              ) : (
                                <li
                                  className={
                                    employerProfilePageResponse
                                      ? "list-unstyled ms-5 "
                                      : "list-unstyled ms-5 w-75 placeholder rounded-2"
                                  }
                                >
                                  {companyDetails.industrySector.length > 20
                                    ? `${companyDetails.industrySector.slice(
                                      0,
                                      20
                                    )}..`
                                    : companyDetails.industrySector}
                                </li>
                              )}
                              <hr />
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Photo upload Modal */}
        <div
          className="modal fade"
          id="profilePhotoModal"
          aria-hidden="true"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                  Organization Logo Upload
                </h1>
                <button
                  id="employerCloseUploadProfilePhotoButton"
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="card border-0 h-100 rounded-4">
                  <div className="card-body d-flex align-items-center justify-content-center">
                    <div className="w-100">
                      <div className="w-100 ">
                        <div className="row justify-content-center p-0">
                          <div className="pic-holder mb-0  w-75">
                            <div className="company-logo-container rounded-0">
                              <img
                                id="profilePic"
                                name="profile_pic"
                                src={companyPicture}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <p className="text-center  image-format-text">
                          (Only .jpeg, .jpg, .png, .JPEG, .JPG, .PNG, .HEIC
                          formats are supported)
                        </p>
                      </div>
                      <div className="text-center pt-4">
                        <button
                          id="employerUploadProfilePhotoButton"
                          type="button"
                          htmlFor="fileInput"
                          className="btn btn-brand-color mx-3 upload-btn"
                          data-bs-dismiss="modal"
                          onClick={() =>
                            document.getElementById("company-photo").click()
                          }
                        >
                          <input
                            type="file"
                            name="profile_pic"
                            id="company-photo"
                            hidden
                            className="form-control"
                            onChange={handleCompanyPictureUpload}
                          />

                          <span>Upload Logo</span>
                        </button>
                        {isCompanyPictureUploaded === true ||
                          !companyPicture.includes(
                            "default_profile_picture.png"
                          ) ? (
                          <button
                            id="employerDeleteUploadProfilePhotoButton"
                            type="button"
                            className={`btn btn-outline-secondary profile-picture-delete-button`}
                            data-bs-toggle="modal"
                            data-bs-target="#deletePhotoModal"
                          >
                            <span>Delete Logo</span>
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Photo delete Modal */}
        <div
          className="modal fade"
          id="deletePhotoModal"
          aria-hidden="true"
          aria-labelledby="deletePhotoModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deletePhotoModal">
                  Delete Organization Logo
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  id="deleteProfilePhotoModalConfirmationModal"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                Are you sure you want to delete this logo?
                <div className="text-center pt-4">
                  <button
                    id="cancelDeletePhotoButton"
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >
                    <span>Cancel</span>
                  </button>

                  {deleteCompanyLogoSaveLoading ? (
                    <>
                      <button
                        id="deleteProfilePhotoConfirmationButtonLoading"
                        type="button"
                        className="btn btn-brand-color mx-3 upload-btn opacity-75 pe-none"
                      >
                        <label className="custom-file-label upload-btn">
                          {mobileScreen ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm text-white "
                                role="status"
                              >
                                <span className="visually-hidden ">
                                  Loading...
                                </span>
                              </span>
                            </>
                          ) : (
                            <>
                              <span
                                className="spinner-border spinner-border-sm text-white me-2"
                                role="status"
                              >
                                <span className="visually-hidden ">
                                  Loading...
                                </span>
                              </span>
                              Deleting
                            </>
                          )}
                        </label>
                      </button>
                    </>
                  ) : (
                    <button
                      id="deleteProfilePhotoDeleteButton"
                      type="button"
                      className="btn btn-brand-color mx-3 upload-btn"
                    >
                      <label
                        className="custom-file-label upload-btn"
                        onClick={handleDeleteCompanyPicture}
                      >
                        Delete
                      </label>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* bottom  content */}
      <div className={`${mobileScreen ? "px-3" : "p-5"} py-3 `}>
        <div className="card mt-3 border-0 shadow-sm rounded-4 employer-about-card mb-3 py-3">
          <div className="card-body">
            <div className="d-flex justify-content-between ms-1">
              <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                <FaUserTie
                  className={
                    employerProfilePageResponse
                      ? "me-3 brand-color fs-4"
                      : "me-3  fs-4 placeholder rounded-2"
                  }
                />
                <span
                  className={
                    employerProfilePageResponse
                      ? ""
                      : "placeholder px-3 w-100 py-1  rounded-1"
                  }
                >
                  About the Organization
                </span>
              </label>

              {
                Cookies.get("user_role") !== "recruiter" ?
                  editIconClicked ? (
                    <span
                      id="aboutTheOrganizationField"
                      className={
                        employerProfilePageResponse ? "" : "placeholder rounded-2"
                      }
                    >
                      <button
                        id="saveAboutTheOrganizationButton"
                        type="button"
                        title="Save about"
                        className={
                          employerProfilePageResponse
                            ? "btn btn-sm btn-brand-color px-3 d-flex align-items-center gap-2 "
                            : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                        }
                        onClick={() => handleAboutSaveClick()}
                      >
                        {mobileScreen ? (
                          <MdSave />
                        ) : (
                          <>
                            <MdSave /> Save
                          </>
                        )}
                      </button>
                    </span>
                  ) : (
                    <span
                      className={
                        employerProfilePageResponse ? "" : "placeholder rounded-2 "
                      }
                    >
                      <button
                        id="editAboutTheOrganizationButton"
                        type="button"
                        title="Edit about"
                        className={
                          employerProfilePageResponse
                            ? "btn btn-sm btn-outline-custom-color px-3 d-flex align-items-center gap-2"
                            : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                        }
                        onClick={handleAboutEditOrSaveIcon}
                      >
                        {mobileScreen ? (
                          <MdModeEditOutline />
                        ) : (
                          <>
                            <MdModeEditOutline /> Edit
                          </>
                        )}
                      </button>
                    </span>
                  )
                  :
                  null
              }
            </div>

            {editIconClicked ? (
              <>
                <div className="ps-5">
                  <textarea
                    id="employerAboutTheOrganizationField"
                    className={
                      employerProfilePageResponse
                        ? "w-100 p-3 textarea mb-3 mt-4 "
                        : "placeholder px-3 w-100 py-1  rounded-2"
                    }
                    value={organizationAboutContent}
                    rows={4}
                    placeholder={
                      employerProfilePageResponse
                        ? "Please enter your text here"
                        : ""
                    }
                    onChange={handleOrganizationAboutContentChange}
                    maxLength="900"
                  ></textarea>
                </div>
              </>
            ) : (
              <p
                className={
                  employerProfilePageResponse
                    ? "text-grey text-break px-5 py-3 mt-2 "
                    : "text-break  mt-4 placeholder rounded-2 w-100"
                }
              >
                {organizationAboutContent
                  ? organizationAboutContent
                  : "Please enter your text here"}
              </p>
            )}
          </div>
        </div>

        <div className="card mt-4 border-0 shadow-sm rounded-4 overflow-hidden placeholder-glow">
          <div className="card-body px-0 pb-0">
            <div className="d-flex justify-content-between ms-1  px-3">
              <div className="col-8">
                <label className="profile-side-headers d-flex align-items-center">
                  <RiTeamFill
                    className={
                      employerProfilePageResponse
                        ? "me-3 brand-color fs-4"
                        : "me-3  fs-4 placeholder rounded-2"
                    }
                  />

                  <span
                    className={
                      employerProfilePageResponse
                        ? ""
                        : "placeholder px-3 w-100 py-1  rounded-1"
                    }
                  >
                    Employer Details
                  </span>
                </label>
              </div>

              <div className="col d-flex align-items-center justify-content-end">
                <button
                  id="addEmployerDetailsButton"
                  type="button"
                  title="Employer Details"
                  className={
                    employerProfilePageResponse
                      ? "btn btn-sm btn-brand-color px-3 py-2 rounded-2 d-flex align-items-center gap-2"
                      : "btn px-3 d-flex align-items-center gap-2 placeholder rounded-2"
                  }
                  data-bs-toggle="modal"
                  data-bs-target="#adduserModal"
                  onClick={disableAddUserFunction() ? null : (e) => { handleResetAddUSers() }}
                  disabled={disableAddUserFunction() || ["recruiter"]?.includes(Cookies.get("user_role") || "")} >
                  {mobileScreen ?
                    <BiEdit color="white" size={16} />
                    :
                    <>
                      <BiEdit color="white" size={16} /> Add Users
                    </>
                  }
                </button>

                {
                  !["premium", "platinum"].includes(pricing_category) ?
                    <div className="info-icon ps-2 w-5">
                      <span
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        className="text-secondary"
                      >
                        <FiInfo size={17} />
                      </span>
                      {isHovered && (
                        <div className="info-hover-text bg-secondary-subtle p-1 mt-3 px-2">
                          Upgrade to a Premium or Platinum plan to unlock the ability to add users
                        </div>
                      )}
                    </div>
                    :
                    null
                }
              </div>
            </div>

            {hiringTeamArray && !hiringTeamArray.length === 0 ?
              <p
                className={
                  employerProfilePageResponse
                    ? "text-grey mt-3 px-3"
                    : "placeholder px-3 w-50 py-1 px-3 mt-3 rounded-1"
                }
              >
                Your experience details will be displayed here
              </p>
              :
              hiringTeamArray?.map((team, teamInd) => (
                <div className={`w-100  ${Cookies.get("id") == team?.user_id ? "logged_user_card" : ""}`}>
                  <div className={`px-4 px-md-5 py-3 ${teamInd === 0 ? 'mt-4' : ''} border-bottom`} >
                    <div className={`d-flex flex-wrap justify-content-between mt-3`}>
                      <div className="col-12 d-flex d-md-none flex-wrap justify-content-end">
                        {editFunDynamicProfile(team)}

                        {deleteFunDynamicProfile(team)}
                      </div>

                      <div className="text-grey profile-inner-headers placeholder-glow d-inline-block w-75">
                        <span className="">
                          <span className={employerProfilePageResponse
                            ? "text-black me-1"
                            : "text-black me-1 placeholder rounded-2"
                          }>
                            {team?.first_name}
                          </span>
                          <span
                            className={
                              employerProfilePageResponse
                                ? "text-black"
                                : "text-black placeholder rounded-2 me-2"
                            }
                          >
                            {team?.last_name}
                          </span>
                          <span
                            className={
                              employerProfilePageResponse
                                ? ""
                                : "placeholder rounded-2"
                            }
                          >
                            &nbsp;&nbsp;|
                          </span>{" "}
                          <span
                            className={
                              employerProfilePageResponse
                                ? ""
                                : "placeholder rounded-2"
                            }
                          >
                            {team?.title}
                          </span>
                        </span>
                      </div>
                    </div>

                    <label className={`profile-descriptions mt-2 d-flex justify-content-between ${hiringTeamArray?.length && teamInd !== hiringTeamArray?.length - 1 ? "" : "pb-4"}`}>
                      <div className="d-flex flex-wrap gap-2 col-9">
                        <span
                          className={
                            employerProfilePageResponse
                              ? "d-flex align-items-center gap-2 me-3 managed_by_employer"
                              : "d-flex align-items-center gap-2 me-3 placeholder rounded-2"
                          }
                        >
                          <HiOutlineBriefcase className="" /> {" "}
                          Managed post :
                          <span className="">{team?.assigned_jobs_count}</span>
                        </span>

                        <span
                          className={
                            employerProfilePageResponse
                              ? "d-flex align-items-center gap-2 me-3 "
                              : "d-flex align-items-center gap-2 me-3 placeholder rounded-2"
                          }
                        >
                          <TbPhone className="" />{" "}
                          {`+${team?.country_code} ${team?.phone_number}`}
                        </span>

                        <span
                          className={
                            employerProfilePageResponse
                              ? "d-flex align-items-center gap-2 me-3"
                              : "d-flex align-items-center gap-2 me-3 placeholder rounded-2"
                          }
                        >
                          <BiEnvelope />
                          {/* <span className="text-wrap col-10"> */}
                          {team?.email_id}
                          {/* </span> */}
                        </span>

                        <span
                          className={
                            employerProfilePageResponse
                              ? "d-flex align-items-center gap-2"
                              : "d-flex align-items-center gap-2 placeholder rounded-2"
                          }
                        >
                          <BiUserPin /> {userType(team?.role_name)}
                        </span>
                      </div>

                      <div className="d-none d-md-flex flex-wrap justify-content-end">
                        {editFunDynamicProfile(team)}

                        {deleteFunDynamicProfile(team)}
                      </div>
                    </label>
                  </div>
                </div>
              ))
            }
          </div>
        </div>


        {/* Add user Modal*/}
        <div
          className="modal fade"
          id="adduserModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header ps-4 border-0">
                <p className="modal-title fs-5" id="staticBackdropLabel">
                  {recuriterEdit ? "Edit" : "Add"} Users
                </p>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closeAdduserModal"
                ></button>
              </div>
              <div className="modal-body">
                <form className="row g-3 px-4 pb-3 align-items-center">
                  <div className="col-md-6">
                    <label htmlFor="addUserFristName" className="form-label">
                      First Name
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      id="addUserFristName"
                      value={addUserInputValues.first_name}
                      onChange={(e) =>
                        handleAddUserInputValues("first_name", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="addUserLastName" className="form-label">
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      id="addUserLastName"
                      value={addUserInputValues.last_name}
                      onChange={(e) =>
                        handleAddUserInputValues("last_name", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="addUserTitle" className="form-label">
                      Designation
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      id="addUserTitle"
                      value={addUserInputValues.designation}
                      onChange={(e) =>
                        handleAddUserInputValues("designation", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="addUserPhone" className="form-label">
                      Phone Number
                    </label>

                    <PhoneInput
                      id="floatingInput"
                      specialLabel=""
                      country={dialCode === "" ? "us" : dialCode}
                      dataTestid="mobileNumber"
                      countryCodeEditable={false}
                      enableSearch
                      className="profile_add_user_phone_input"
                      onChange={(e, phone) => {
                        handlePhoneInput(e, phone, "contactno")
                        handleAddUserInputValues("contact_number", { phone_number: e, country_code: phone.dialCode })
                      }
                      }
                      value={`${countryCode}${editHiringTeamInputValues.contactNumber}`}
                      inputProps={{
                        alt: "mobileNumber",
                        type: "tel",
                        placeholder: "Mobile Number",
                        required: true,
                      }}
                    />
                  </div>

                  <div className="col-12">
                    <label htmlFor="addUserEmail" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control py-2"
                      id="addUserEmail"
                      value={addUserInputValues.email_id}
                      onChange={(e) =>
                        handleAddUserInputValues("email_id", e.target.value)
                      }
                      disabled={recuriterEdit}
                    />
                  </div>

                  <div className="col-md-6 cursorPointer" onClick={() => document.getElementById("adminAccess")?.click()}>
                    <label htmlFor="adminAccess" className="form-label">
                      Access
                    </label>
                    <div className="form-control d-flex justify-content-between">
                      <div>
                        <input
                          className="form-check-input me-3"
                          type="radio"
                          name="accessType"
                          id="adminAccess"
                          checked={addUserInputValues.access_type === "employer_sub_admin"}
                          onChange={() =>
                            handleAddUserInputValues("access_type", "employer_sub_admin")
                          }
                          disabled={
                            Cookies.get("user_role") === "employer_sub_admin" ?
                              ["recruiter", ""].includes(edit_type) ?
                                false
                                :
                                true
                              :
                              ["recruiter"].includes(Cookies.get("user_role"))
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="adminAccess"
                        >
                          Admin Access
                        </label>
                      </div>
                      <div className="info-icon">
                        <span
                          onMouseEnter={() => setIsAdminHovered(true)}
                          onMouseLeave={() => setIsAdminHovered(false)}
                          className="text-secondary"
                        >
                          <FiInfo size={17} />
                        </span>
                        {isAdminHovered && (
                          <div className="info-hover-text bg-secondary-subtle p-1 mt-3 px-2">
                            Full access to all features and settings.
                          </div>
                        )}

                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 cursorPointer" onClick={() => document.getElementById("recruiterAccess")?.click()}>
                    <label htmlFor="recruiterAccess" className="form-label" ></label>
                    <div className="form-control mt-2 d-flex justify-content-between">
                      <div>
                        <input
                          className="form-check-input me-3"
                          type="radio"
                          name="accessType"
                          id="recruiterAccess"
                          checked={addUserInputValues.access_type === "recruiter"}
                          onChange={() =>
                            handleAddUserInputValues("access_type", "recruiter")
                          }
                          disabled={
                            Cookies.get("user_role") === "employer_sub_admin" ?
                              ["recruiter", ""].includes(edit_type) ?
                                false
                                :
                                true
                              :
                              ["recruiter"].includes(Cookies.get("user_role"))
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="recruiterAccess"
                        >
                          Recruiter Access
                        </label>
                      </div>
                      <div className="info-icon">
                        <span
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                          className="text-secondary"
                        >
                          <FiInfo size={17} />
                        </span>
                        {isHovered && (
                          <div className="info-hover-text bg-secondary-subtle mt-3 p-1 px-2">
                            Limited access. Upgrade options are hidden.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="px-4">
                <div className="modal-footer d-flex flex-nowrap border-0">
                  <button
                    type="button"
                    className="btn btn-outline-secondary col-6 px-0"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-brand-color col-6"
                    onClick={recuriterEdit ?
                      () => handleNewUserEditOrAdd("/update_team_members")
                      :
                      () => handleNewUserEditOrAdd("/add_team_members")}
                  >
                    {recuriterEdit ? "Update" : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Delete user Modal*/}
        <div
          className="modal fade"
          id="deleteHiringTeamModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="deleteHiringTeamModal"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deleteHiringTeamModal">
                  Delete User
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  id="deleteUserModal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                <div className="w-100 py-4">
                  <img src="https://cdn.2ndcareers.com/delete_user_icon.png" width="190rem" height="180rem" />
                </div>

                <h6>Are you sure you want to delete this User?</h6>
                <p className="text-start pt-2 employer_multiple_user_note">
                  <span className="pe-1 note_brand_color">
                    Note :
                  </span>
                  <span className="text-secondary">
                    Deleting this user will transfer all managed posts to the account owner. Please reassign any posts to the apporopiate users before proceeding
                  </span>
                </p>

                <div className="text-center d-flex flex-wrap pt-4">
                  <div className="col-6 p-1">
                    <button
                      type="button"
                      className="btn btn-outline-secondary w-100"
                      data-bs-dismiss="modal"
                    >
                      <span>Cancel</span>
                    </button>
                  </div>

                  <div className="col-6 p-1">
                    <button
                      type="button"
                      className="btn btn-brand-color upload-btn w-100"
                      onClick={() => handleDeleteUser(deleteUserId)}
                    >
                      <label className="custom-file-label upload-btn">
                        Delete
                      </label>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit hiring team Modal */}
        <div
          className="modal fade"
          id="editHiringTeamModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                  Employer Details
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  id="updateExperienceClose"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body border-bottom-0">
                <div className="container modal-form-container">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="firstName" className="form-label">
                        First name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        id="firstName"
                        aria-describedby="firstName"
                        placeholder="Enter your first name"
                        value={editHiringTeamInputValues.firstName}
                        onChange={(e) => handleEditHiringTeamInputValues(e)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="lastName" className="form-label">
                        Last name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        id="lastName"
                        aria-describedby="lastName"
                        placeholder="Enter your last name"
                        value={editHiringTeamInputValues.lastName}
                        onChange={(e) => handleEditHiringTeamInputValues(e)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="designation" className="form-label">
                        Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="designation"
                        id="designation"
                        aria-describedby="designation"
                        placeholder="Enter your designation"
                        value={editHiringTeamInputValues.designation}
                        onChange={(e) => handleEditHiringTeamInputValues(e)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="contactNumber" className="form-label">
                        Contact number
                      </label>

                      <PhoneInput
                        id="floatingInput"
                        specialLabel=""
                        country={dialCode === "" ? "us" : dialCode}
                        dataTestid="mobileNumber"
                        countryCodeEditable={false}
                        enableSearch
                        onChange={(e, phone) =>
                          handlePhoneInput(e, phone, "contactno")
                        }
                        value={`${countryCode}${editHiringTeamInputValues.contactNumber}`}
                        inputProps={{
                          alt: "mobileNumber",
                          type: "tel",
                          placeholder: "Mobile Number",
                          required: true,
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer  border-top-0 me-2">
                {employerDetailsSaveLoading ? (
                  <button
                    id="employerDetailsModalSaveButtonLoading"
                    type="submit"
                    className="btn btn-brand-color px-3 pe-none opacity-75"
                  >
                    {mobileScreen ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm text-white "
                          role="status"
                        >
                          <span className="visually-hidden ">Loading...</span>
                        </span>
                      </>
                    ) : (
                      <>
                        <span
                          className="spinner-border spinner-border-sm text-white me-2"
                          role="status"
                        >
                          <span className="visually-hidden ">Loading...</span>
                        </span>
                        Updating
                      </>
                    )}
                  </button>
                ) : (
                  <button
                    id="employerDetailsModalSaveButton"
                    type="submit"
                    className="btn btn-brand-color px-3"
                    onClick={(e) => handleUpdateHiringTeam(e, "Save")}
                  >
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Delete experience modal  */}
        <div
          className="modal fade"
          id="deleteExperienceModal"
          aria-hidden="true"
          aria-labelledby="deleteExperienceModal"
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deleteExperienceModal">
                  Delete Experience
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center pb-4">
                Are you sure you want to delete this information?
                <div className="text-center pt-4">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >
                    <span>Cancel</span>
                  </button>
                  <button
                    type="button"
                    className="btn btn-brand-color mx-3 upload-btn"
                    data-bs-dismiss="modal"
                  >
                    <label className="custom-file-label upload-btn">
                      Delete
                    </label>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </section >
  );
};

export default EmployerProfile;